import { DAYS } from "../lib/planning";

export function DayPills({ days, allowed, onToggle, testPrefix }) {
    return (
        <div className="flex flex-wrap gap-1">
            {DAYS.map((d) => {
                const enabled = !allowed || allowed.includes(d.v);
                const on = days.includes(d.v);
                return (
                    <button
                        key={d.v}
                        type="button"
                        disabled={!enabled}
                        onClick={() => onToggle(d.v)}
                        className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${on ? "bg-[#376DB3] text-white" : enabled ? "bg-slate-100 text-slate-600 hover:bg-slate-200" : "bg-slate-50 text-slate-300"}`}
                        data-testid={`${testPrefix}-${d.v}`}
                    >
                        {d.l}
                    </button>
                );
            })}
        </div>
    );
}
